<template>
  <div id="SocialList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">動態列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">社交動態</li>
              <li class="breadcrumb-item active">動態列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter">
              <el-select v-model="SGL_IsShow">
                <el-option label="請選擇" :value="null"></el-option>
                <el-option label="已隱藏" :value="0"></el-option>
                <el-option label="未隱藏" :value="1"></el-option>
                <el-option label="公開" :value="2"></el-option>
              </el-select>
              <el-button @click="SGL_Type = -1" :class="{ current: SGL_Type == -1 }">全部</el-button>
              <el-button @click="SGL_Type = 2" :class="{ current: SGL_Type == 2 }">動態 (純文字)</el-button>
              <el-button @click="SGL_Type = 1" :class="{ current: SGL_Type == 1 }">動態 (含相片)</el-button>
              <el-button @click="SGL_Type = 0" :class="{ current: SGL_Type == 0 }">動態 (含影片)</el-button>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-table :data="GetList" v-loading="loading" border row-key="id">
                  <el-table-column width="200" label="動態內容" prop="sgL_Content">
                  </el-table-column>
                  <el-table-column label="用戶">
                    <template slot-scope="scoped">
                      <span class="b-user-icon mr-1">
                        <img :src="scoped.row.userLogoBig" class="user-image img-circle" />
                      </span>
                      <span class="b-username">
                        <a href="javascript:void(0);">
                          {{ scoped.row.sgL_UsersName }}
                        </a>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="瀏覽量" prop="sgL_PG_CTotalView"></el-table-column>
                  <el-table-column label="讚好" prop="sgL_PG_CTotalLike"></el-table-column>
                  <el-table-column label="回應" prop="sgL_PG_CTotalMesg"></el-table-column>
                  <el-table-column label="分享" prop="sgL_PG_CTotalShare"></el-table-column>
                  <el-table-column label="發佈時間" prop="sgL_PG_CAddTimerF"></el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" @click="Look(scope.row)">
                        查看
                      </el-button>
                      <el-button v-if="scope.row.sgL_IsShow != 0" type="primary" size="mini" @click="UpdateFunc(scope.row)">
                        隱藏
                      </el-button>
                      <el-button v-else type="primary" size="mini" @click="UpdateFunc(scope.row)">
                        顯示
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination v-if="pageParams.pageshow" :currentPage="pageParams.currentPage" :total="pageParams.total"
                  :limit="pageParams.limit" :small="true" @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange" />
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      SGL_IsShow: null,
      SGL_Type: -1,
      SocialList: null,
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      loading: true,
    };
  },
  created() {
    this.getSocialList();
  },
  watch: {
    SGL_Type: {
      handler(newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
        }
      },
    },
    SGL_IsShow: {
      handler(newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
        }
      },
    },
  },
  methods: {
    Look(item) {
      this.$router.push({ name: "feed", query: { id: item.id } });
    },
    getSocialList() {
      this.loading = true;
      let params = {
        SGL_IsShow: this.SGL_IsShow,
        SGL_Type: this.SGL_Type,
        IsLogin: true,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      this.$api.social
        .AdminMoiveCommunity(params)
        .then((res) => {
          if (res.data.success) {
            this.SocialList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch()
        .then((obj) => {
          this.loading = false;
        });
    },
    UpdateFunc(item) {
      let params = {
        sgL_MoiveTempId: item.sgL_MoiveTempId,
        sgL_Content: "",
        sgL_Type: item.sgL_Type,
        id: item.id,
      };
      if (item.sgL_IsShow == 1 || item.sgL_IsShow == 2) {
        this.$prompt(
          `動態隱藏後，所有人皆無法看到該動態。管理員可從後臺將動態改回顯示狀態。
        操作原因／備註`,
          "確認隱藏動態？",
          {
            confirmButtonText: "是，請隱藏",
            cancelButtonText: "取消",
          }
        ).then(({ value }) => {
          params.sgL_Content = value;
          params.sgL_IsShow = 0;
          this.Update(params);
        });
      } else {
        this.$confirm("確認顯示?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          params.sgL_IsShow = 1;
          this.Update(params);
        });
      }
    },
    Update(params) {
      this.$api.social
        .AdminUpdate(params)
        .then((res) => {
          if (res.data.success) {
            Message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
            this.getSocialList();
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch()
        .then((obj) => {
          this.loading = false;
        });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getSocialList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getSocialList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.SocialList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminSocial/socialList.vue